import axios from 'axios';
import { has, isObject } from 'lodash-es';
export class APIClient {
  baseUrl = '';
  appSecret = '';
  debugMode = false;
  endpoints = {};

  constructor(baseUrl, appSecret, debugMode = false) {
    this.baseUrl = baseUrl;
    this.appSecret = appSecret;
    this.debugMode = debugMode;
  }

  register(endpoint) {
    this.endpoints[endpoint.getAction()] = endpoint;
  }

  isApiAction(action) {
    return isObject(action) && has(action, 'type') && has(this.endpoints, action.type);
  }

  getApiEndpoint(action) {
    if (!this.isApiAction(action)) {
      throw new Error('Invalid API action');
    }
    return this.endpoints[action.type];
  }

  call(action) {
    const endpoint = this.getApiEndpoint(action);

    const url = endpoint.getUrl(this.baseUrl, action);
    const method = endpoint.getRequestType();
    const headers = endpoint.getHeaders(this.appSecret);
    const params = endpoint.getParams(action);
    const data = endpoint.formatData(action);

    const config = {
      method,
      url,
      headers,
      params,
      data,
    };

    return (this.debugMode ? endpoint.makeMockRequest : endpoint.makeRequst).call(endpoint, config);
  }
}

export class APIEndpoint {
  url = '';
  action = '';
  appSecret = '';
  requiresAuth = false;
  requestType = 'GET';

  getAction() {
    return this.action;
  }

  getUrl(baseUrl, action) {
    return `${baseUrl}${this.url}`;
  }

  getParams(action) {
    return null;
  }

  getRequestType() {
    return this.requestType;
  }

  getHeaders(appSecret) {
    return {
      'Content-Type': 'application/json',
      'AppSecret': appSecret,
    };
  }

  validateData(data) {
    return true;
  }

  formatData(action) {
    return action.payload;
  }

  makeRequst(config) {
    return axios(config);
  }

  makeMockRequest(config) {
    return Promise.resolve();
  }
}
